export default "<div class=\"grid\">\n    <div class=\"grid__content\">\n        <router-outlet></router-outlet>\n    </div>\n</div>"